import React, { useEffect } from "react";
import { useNavigate, useRouteError } from "react-router-dom";
import { LuTriangleAlert } from "react-icons/lu";
import { Button } from "../components/ui";
import { StatusCard } from "../components/patterns/StatusCard";
import { resolveMessage, toAppError } from "../lib/feedback";
import { reportError } from "../lib/monitoring";
import { t } from "../i18n";
import { PATHS } from "./paths";

// errorElement da raiz: qualquer erro de render ou de loader cai aqui, em vez da tela branca.
export const ErrorScreen: React.FC = () => {
  const raw = useRouteError();
  const error = toAppError(raw);
  const navigate = useNavigate();
  useEffect(() => reportError(raw, error), [raw]); // eslint-disable-line react-hooks/exhaustive-deps
  const { title, body } = resolveMessage(error);

  return (
    <StatusCard
      tone="danger"
      icon={<LuTriangleAlert size={28} />}
      title={title}
      actions={
        <>
          <Button variant="primary" onClick={() => window.location.reload()}>{t("common.retry")}</Button>
          <Button variant="text" onClick={() => navigate(PATHS.newOrder)}>{t("common.goHome")}</Button>
        </>
      }
    >
      <p>{body}</p>
      {error.requestId && <p className="text-caption text-fg-subtle">{t("common.errorCode", { code: error.requestId })}</p>}
    </StatusCard>
  );
};
